"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNewsletterDialogContext = exports.defaultNewsletterDialogContextValues = exports.NewsletterDialogContextProvider = exports.NewsletterDialogContext = void 0;
var _react = require("react");
var _hooks = require("../../../../../../hooks");
var _types = require("../../types");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- context */

const defaultNewsletterDialogContextValues = exports.defaultNewsletterDialogContextValues = {
  content: {
    buttonAction: _types.ButtonAction.Submit,
    buttonText: '',
    emailLabel: '',
    icon: 'info',
    invalidEmailLabel: '',
    ppLinkText: '',
    ppText: '',
    ppUrl: '',
    showButton: false,
    showForm: false,
    text: '',
    title: ''
  },
  status: _types.SubscriptionProcessStatus.Initial,
  setStatus: () => {}
};
const NewsletterDialogContext = exports.NewsletterDialogContext = /*#__PURE__*/(0, _react.createContext)(defaultNewsletterDialogContextValues);
const {
  Provider
} = NewsletterDialogContext;
const NewsletterDialogContextProvider = ({
  children
}) => {
  const [status, setStatus] = (0, _react.useState)(_types.SubscriptionProcessStatus.Initial);
  const {
    newsletterSubsciptionConfiguration
  } = (0, _hooks.useFooter)();
  const content = (0, _react.useMemo)(() => (0, _utils.getContent)({
    newsletterSubsciptionConfiguration,
    status
  }), [newsletterSubsciptionConfiguration, status]);
  const value = (0, _react.useMemo)(() => ({
    content,
    status,
    setStatus
  }), [content, status]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.NewsletterDialogContextProvider = NewsletterDialogContextProvider;
const useNewsletterDialogContext = () => (0, _react.useContext)(NewsletterDialogContext);
exports.useNewsletterDialogContext = useNewsletterDialogContext;